var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    id: "social-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.387 20.411c3.042-1.617 6.056-3.222 9.11-4.844-3.057-1.638-6.074-3.25-9.11-4.878v9.722zm-8.036 5.39c-1.106-.372-1.852-1.113-2.252-2.24-.976-2.75-1.262-14.255.615-16.519.64-.774 1.467-1.23 2.45-1.338 5.06-.558 20.693-.479 22.494.188 1.054.39 1.805 1.097 2.211 2.18 1.068 2.844 1.104 13.186-.137 15.925-.341.742-.891 1.267-1.589 1.64-1.887 1.018-21.308 1.003-23.792.165z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.633462846e8a6fe5e6d1cd802e412273.svg";
export { ForwardRef as ReactComponent };